export type AddCounterpartyRefusalCode =
	| 'DOCUMENT_CLOSED'
	| 'NO_OUTSTANDING_SIGNATURES'
	| 'UNSUPPORTED_PROVIDER'
	| 'NOT_READY_FOR_SIGNING'
	| 'SIGNATURE_HEADROOM_EXHAUSTED'
	| 'SIGNATURE_HEADROOM_UNKNOWN';

// Mirrors REFUSAL_MESSAGES in libs/modules/src/documentWorkflow/addCounterparty/addCounterparty.types.ts.
// The frontend can't import from libs/modules, so this is a deliberate duplicate — keep it in sync.
export const REFUSAL_COPY: Record<AddCounterpartyRefusalCode, string> = {
	SIGNATURE_HEADROOM_EXHAUSTED:
		'The signature pages on this document are full. Adding a party would need a new page, which would invalidate the signatures already collected. Revoke this document and send a new one to include the party.',
	SIGNATURE_HEADROOM_UNKNOWN:
		'This document was issued before signature-page capacity was recorded, so we cannot tell whether a party still fits. Revoke this document and send a new one to include the party.',
	NO_OUTSTANDING_SIGNATURES: 'This document has no outstanding signatures.',
	DOCUMENT_CLOSED: 'This document is no longer open for signature.',
	UNSUPPORTED_PROVIDER:
		'This document has no signing configuration, so a party cannot be added. Revoke this document and send a new one to include the party.',
	NOT_READY_FOR_SIGNING:
		'This document has not been generated yet — a party can be added once it has.',
};

/**
 * Refusals the manager can only clear by revoking and sending a fresh document, so the copy is
 * followed by a link into the list's revoke mode.
 *
 * Not re-issue: that resets an existing instance's expired/declined signatures for re-invitation
 * and never touches the signing roles, so it cannot add a party.
 */
export const REVOKE_REFUSALS: ReadonlySet<string> = new Set<AddCounterpartyRefusalCode>([
	'SIGNATURE_HEADROOM_EXHAUSTED',
	'SIGNATURE_HEADROOM_UNKNOWN',
	'UNSUPPORTED_PROVIDER',
]);

/** How one slot should be filled. Mirrors the backend's "user, invite, or neither". */
export type SlotMode = 'UNASSIGNED' | 'USER' | 'INVITE';

export interface SlotFormValues {
	mode: SlotMode;
	userId: string;
	firstName: string;
	lastName: string;
	email: string;
}

export interface AddCounterpartyFormValues {
	name: string;
	slotCount: number;
	/** Always MAX_SLOTS long; only the first `slotCount` are rendered and submitted. */
	slots: SlotFormValues[];
}

export interface AssignableUser {
	id: string;
	label: string;
}

/** Slot payload the endpoint takes — exactly one branch, or neither for an open slot. */
export interface SlotSubmission {
	userId?: string;
	invite?: { firstName: string; lastName: string; email: string };
}
